// Support/Donation Configuration
// Update these links with your actual donation platform URLs

export const SUPPORT_CONFIG = {
  // Enable/disable the support button
  enabled: true,
  
  // Your actual donation links - REPLACE THESE!
  platforms: {
    buyMeACoffee: {
      enabled: true,
      url: 'https://buymeacoffee.com/markersync', // Replace with your actual username
      name: 'Buy Me A Coffee',
      icon: '',
      color: 'bg-yellow-500 hover:bg-yellow-600',
      description: 'Support with a coffee'
    },
    
    kofi: {
      enabled: false,
      url: 'https://ko-fi.com/markersync', // Replace with your actual username
      name: 'Ko-fi',
      icon: '',
      color: 'bg-pink-500 hover:bg-pink-600',
      description: 'Support on Ko-fi'
    },
    
    paypal: {
      enabled: true,
      url: 'https://paypal.me/markersync',
      name: 'PayPal',
      icon: '',
      color: 'bg-blue-500 hover:bg-blue-600',
      description: 'Donate via PayPal'
    },
    
    githubSponsors: {
      enabled: false, // Set to true when you have GitHub Sponsors set up
      url: 'https://github.com/sponsors/MarianaPerna07', // Replace with your GitHub username
      name: 'GitHub Sponsors',
      icon: '',
      color: 'bg-gray-800 hover:bg-gray-900',
      description: 'Sponsor on GitHub'
    },
  },
  
  // Customizable messages
  messages: {
    floating: {
      title: 'Support this project!',
      subtitle: 'Help keep this tool free and growing'
    },
    footer: {
      title: 'Gostaste desta ferramenta?',
      subtitle: 'Considera fazer uma pequena contribuição para manter este projeto gratuito.'
    },
    thankYou: 'Cada contribuição faz a diferença!'
  },
  
  // Analytics (optional - for tracking clicks)
  analytics: {
    enabled: false,
    trackClicks: false // Set to true if you want to track donation button clicks
  }
};

// Helper function to get enabled platforms
export const getEnabledPlatforms = () => {
  return Object.entries(SUPPORT_CONFIG.platforms)
    .filter(([key, platform]) => platform.enabled)
    .map(([key, platform]) => ({ ...platform, platformKey: key }));
};

// Helper function to check if support is enabled
export const isSupportEnabled = () => {
  return SUPPORT_CONFIG.enabled && getEnabledPlatforms().length > 0;
};